$(document).ready(function () {
  $('.na_sel_box[data="onetime"]').trigger('click');

  var randomNumber = Math.floor(Math.random() * 4) + 1;
  $('.cart_review[data="' + randomNumber + '"]').removeClass('hidden');
  $('body').attr('data-review-widget', randomNumber);
  document.addEventListener('cart-items-change', function (event) {
    setTimeout(function () {
      let randomNumberInCart = $('body').attr('data-review-widget');
      $('.cart_review[data="' + randomNumberInCart + '"]').removeClass('hidden');
    }, 600);
  });

  // Check for reviews every 500ms
  setInterval(function () {
    let randomNumberInCart = $('body').attr('data-review-widget');
    if (randomNumberInCart) {
      $('.cart_review[data="' + randomNumberInCart + '"]').removeClass('hidden');
    }
  }, 500);


  var cookies = document.cookie.split(';');
  var cookiesSet = false;
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf('cookies=set1') === 0) {
      cookiesSet = true;
    }
  }
  if (cookiesSet == false) {
    $('.na_co_out').show();
  }

  $('.na_accept_btn').click(function (evt) {
    evt.preventDefault();
    $('.Avada-CookiesBar_BtnAgree').trigger('click');
    $('.na_co_out').hide();
    document.cookie = "cookies=set1; expires=Thu, 1 Jan 2029 00:00:00 UTC; path=/";
  });

  $('.na_disable_btn').click(function (evt) {
    // evt.preventDefault();
    // $('.Avada-CookiesBar_BtnDeny').trigger('click');
    // $('.na_co_out').hide();
    // document.cookie = "cookies=set1; expires=Thu, 1 Jan 2029 00:00:00 UTC; path=/";
  });


  $('.menu_header_has_childs').click(function (evt) {
    evt.preventDefault();
    $(this).toggleClass('active');
    $(this).closest('li').find('.hea_childs_li').slideToggle();
  });


  $('*:not(.faq_tabs_nav_show_hide) > .faq_tab_n').click(function () {
    $('.faq_tab_n').removeClass('active');
    $(this).addClass('active');
    var data = $(this).attr('data');

    // For blogposts
    if (data == 'all') {
      $('.na_blogs_main').show();
      $('.na_blog_filters').hide();
      $('.na_blog_card-outer').show();
    } else {
      $('.na_blogs_main').hide();
      $('.na_blog_filters').show();
      $('.na_blog_card-outer').hide();
      $('.na_blog_card-outer[data*="' + data + '"]').show();
    }

    $('html, body').animate({
      scrollTop: $(".na_main_headline[data=" + data + "]").offset().top - 64
    }, 500);
  });

  $('.faq_tabs_nav_show_hide > .faq_tab_n').click(function () {
    $('.faq_tab_n').removeClass('active');
    $(this).addClass('active');
    const currentCategory = $(this).attr('data');
    $('.faq_category_outer').addClass('hidden');
    $('.faq_category_outer[data="' + currentCategory + '"]').removeClass('hidden');
  });

  $('.na_col_btn').click(function () {
    $('.na_col_btn').removeClass('active');
    $(this).addClass('active');

    var currentId = $(this).attr('data-id');
    $('.na_collection_outer').hide();
    $('.na_collection_outer[data-id="' + currentId + '"]').show();
  });

  $('.na_sel_box').click(function () {
    $(this).closest('.na_selection_container').find('.na_sel_box').removeClass('active');
    $(this).addClass('active');
  });

  $('.hh_outer_carousel').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000
  });

  $('.na_product_gallery_carousel').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0772/2431/3172/files/Chevron_Left.png?v=1735402737'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0772/2431/3172/files/Chevron_Right.png?v=1735402737'/></button>",
  });

  $('.hh_thousands_carousel').slick({
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0772/2431/3172/files/Icon_button.png?v=1733599328'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0772/2431/3172/files/Icon_button_8f13dc52-4e8d-4441-a641-0659f76e2df6.png?v=1733599328'/></button>",
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
          centerMode: true,
          centerPadding: '20px'
        }
      }
    ]
  });

  $(document).scroll(function () {
    var value = $(document).scrollTop();/* <== here*/

    if (value >= 1700) {
      $('.na_sticky_bar_outer').addClass('active');
    }
    else {
      $('.na_sticky_bar_outer').removeClass('active');
    }
  });

  $('.na_checkbox_form').click(function () {
    $(this).toggleClass('active');
  });



  $('.na_atc:not(.redirect_to_product_page)').click(function (evt) {
    evt.preventDefault();
    const $btn = $(this);
    if ($btn.prop('disabled')) return;

    const currentId = $btn.attr('data-id');
    const currentQty = 1;
    const items = [{ id: currentId, quantity: currentQty }];
    const cartUrl = (window.getCartUrl && window.getCartUrl()) || '/cart';
    const originalText = $btn.text();

    $btn.prop('disabled', true).text('Adding...');

    $.ajax({
      type: "POST",
      url: cartUrl + '/add.js',
      data: { items },
      dataType: "json",
      success: function () {
        $btn.prop('disabled', false).text(originalText);
        if (window.onAddToCartSuccess) window.onAddToCartSuccess(cartUrl);
        else window.location.href = cartUrl;
      },
      error: function () {
        $btn.prop('disabled', false).text(originalText);
        alert('Error adding to cart. Please try again.');
      }
    });
  });

  $(document).on('submit', 'form', function (evt) {
    const form = evt.target;
    if (!form.querySelector('.na_atc_btn') || form.closest('product-form')) return;

    evt.preventDefault();
    const $btn = $(form).find('.na_atc_btn');
    if ($btn.prop('disabled')) return;

    const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    const cartUrl = (window.getCartUrl && window.getCartUrl()) || '/cart';
    const originalText = $btn.text();

    $btn.prop('disabled', true).text('Adding...');

    const formData = new FormData(form);
    fetch(cartAddUrl + '.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        $btn.prop('disabled', false).text(originalText);
        if (data.status && data.status !== 200) {
          alert(data.description || 'Error adding to cart. Please try again.');
          return;
        }
        if (window.onAddToCartSuccess) window.onAddToCartSuccess(cartUrl);
        else window.location.href = cartUrl;
      })
      .catch(function () {
        $btn.prop('disabled', false).text(originalText);
        alert('Error adding to cart. Please try again.');
      });
  });

  $('.hh_thousands_mute').click(function () {
    // Get the current button and associated video
    var $button = $(this);
    var $currentCard = $button.closest('.hh_thousands_card');
    var $currentVideo = $currentCard.find('video');

    // Toggle mute state of the specific video
    var mode = $button.attr('data');
    if (mode === 'muted') {
      // Unmute the selected video
      $currentVideo.prop('muted', false);
      $button.find('.hh_mute__js').hide();
      $button.find('.hh_unmute__js').show();
      $button.attr('data', 'unmuted');
    } else {
      // Mute the selected video
      $currentVideo.prop('muted', true);
      $button.find('.hh_mute__js').show();
      $button.find('.hh_unmute__js').hide();
      $button.attr('data', 'muted');
    }

    // Mute all other videos
    $('.hh_thousands_card').each(function () {
      var $otherCard = $(this);
      var $otherVideo = $otherCard.find('video');
      var $otherButton = $otherCard.find('.hh_thousands_mute');

      // Skip the current video
      if ($currentCard.is($otherCard)) return;

      // Mute other videos
      $otherVideo.prop('muted', true);
      $otherButton.attr('data', 'muted');
      $otherButton.find('.hh_mute__js').show();
      $otherButton.find('.hh_unmute__js').hide();
    });
  });



  function setPaymentsCardPrice() {
    var currentMode = $('.payments .na_sel_box.active').attr('data');
    var currentQuantity = $('.quantityy .na_sel_box.active').attr('data');
    if (currentQuantity == '1') {
      var originalPrice = $('.na_original_product_price__js').attr('data-onetime-price');
    }
    else if (currentQuantity == '2') {
      var originalPrice = 0;
      $('.quantityy .na_sel_box.active').find('.na_selbox_fequency').each(function () {
        var thisPrice = parseFloat($(this).find('option:selected').attr('data-price'));
        originalPrice = originalPrice + thisPrice;
      });
    }
    else if (currentQuantity == '3') {
      var originalPrice = 0;
      $('.quantityy .na_sel_box.active').find('.na_selbox_fequency').each(function () {
        var thisPrice = parseFloat($(this).find('option:selected').attr('data-price'));
        originalPrice = originalPrice + thisPrice;
      });
    }

    var newPriceSub;
    var newPriceOne;
    var comparePrice;

    // na_selbox_fequency

    var serves = 1;
    comparePrice = originalPrice / 100;
    if (currentQuantity == '1') {
      newPriceSub = originalPrice / 100 * 0.95;

      serves = 15;
    }
    else if (currentQuantity == '2') {
      newPriceSub = originalPrice / 100 * 0.85 * 0.95;
      serves = 30;
    }
    else if (currentQuantity == '3') {
      newPriceSub = originalPrice / 100 * 0.75 * 0.95;
      serves = 45;
    }

    if (currentQuantity == '1') {
      newPriceOne = originalPrice / 100;
      comparePrice = comparePrice / 1;
    }
    else if (currentQuantity == '2') {
      newPriceOne = originalPrice / 100 * 0.85;
      comparePrice = comparePrice / 2;
    }
    else if (currentQuantity == '3') {
      newPriceOne = originalPrice / 100 * 0.75;
      comparePrice = comparePrice / 3;
    }


    newPriceSub = (newPriceSub / parseFloat(currentQuantity)).toFixed(2);
    newPriceOneServing = (newPriceOne / serves).toFixed(2);
    newPriceOne = (newPriceOne / parseFloat(currentQuantity)).toFixed(2);
    comparePrice = comparePrice.toFixed(2);

    var currency = '€';

    $('.na_subscription_price__js').find('span').html(currency + newPriceSub);
    $('.na_subscription_price__js_s').find('span').html(currency + newPriceOne);

    $('.na_onetime_price__js').find('span').html(currency + newPriceOne);

    if (currentQuantity != '1') {
      $('.na_selection_container.quantityy .na_sel_box.active').find('.na_sel_curr_price').find('span.money').html(currency + newPriceOne);
      $('.na_selection_container.quantityy .na_sel_box.active').find('s').find('span.money').html(currency + comparePrice);

      $('.na_selection_container.quantityy .na_sel_box.active').find('.curr_title').find('span.money').html(currency + newPriceOneServing);
    }

  }

  setInterval(function () {
    if (String(window.location.href).indexOf('product') != -1) {
      setPaymentsCardPrice();
    }
  }, 500);



  Product = new Object();
  Product.log = window.log;

  Product.initDeliveryEstimation = function () {
    const currentCountry = $('.countr_code_sel__js').attr('value');
    const deliveryEl = $('.pdp-main__product-delivery')
    const deliveryDaysRaw = deliveryEl.data('delivery-days');
    const deliveryMonthsRaw = deliveryEl.data('delivery-months');
    const deliveryDays = Array.isArray(deliveryDaysRaw) ? deliveryDaysRaw.map(d => d.value) : [];
    const deliveryMonths = Array.isArray(deliveryMonthsRaw) ? deliveryMonthsRaw.map(m => m.value) : [];

    const deliveryConditions = deliveryEl.data('delivery-conditions');
    const productDeliveryConditions = deliveryEl.data('product-delivery-conditions');
    const deliveryDefaultEstimation = +(deliveryEl.data('delivery-default-estimation')) || 1;
    Product.log.collapse({ currentCountry, deliveryDays, deliveryMonths, deliveryConditions, productDeliveryConditions, deliveryDefaultEstimation }, "Delivery Data", "success");

    const calcEstimation = (country, conditions, defEst) =>
      (conditions || []).find(c => c.countries?.includes(country))?.delivery_estimation ?? defEst;

    const deliveryEstimation = calcEstimation(currentCountry, productDeliveryConditions || deliveryConditions, deliveryDefaultEstimation);
    Product.calculateDeliveryDate(deliveryEstimation, deliveryDays, deliveryMonths, deliveryConditions);
  },

    Product.calculateDeliveryDate = function (daysToAdd, days, months) {
      const currentDate = new Date();

      const addBusinessDays = (startDate, numDays) => {
        const resultDate = new Date(startDate);
        let addedDays = 0;
        while (addedDays < numDays) {
          resultDate.setDate(resultDate.getDate() + 1);
          if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
            addedDays++;
          }
        }
        return resultDate;
      };

      const firstDeliveryDate = addBusinessDays(currentDate, daysToAdd);
      const formattedDate = `${days[firstDeliveryDate.getDay()]}, ${firstDeliveryDate.getDate()} ${months[firstDeliveryDate.getMonth()]}`;
      $('.pdp-main__product-delivery .delivery_date').text(formattedDate);
    }
  Product.initDeliveryEstimation();

});


document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".kaching-bundles__bar-wrapper")) {
    document.querySelectorAll("h1.na_price_bundle").forEach(function (el) {
      el.style.display = "none";
    });
  }
});
